module.exports = __webpack_public_path__ + "static/media/pol_bg_2.6d4c3136.webp";